/* eslint-disable */

/**
* Import Components
*/
import InitCarousel from './components/carousel.js';

/**
* Init - initalises all project classes
*/
class Init{

	constructor(){
		//Base Initialisers
		new InitCarousel();
	}

}
new Init();
